<template>
  <div>
    <com-dialog :visible.sync="visible" width="70%" :title="type === 'created' ? '新增' : '编辑'">
      <div>
        <div class="flex items-center mb-15px">
          <div class="flex w-80px">分类:</div>
          <el-select v-model="form.refCategory" placeholder="" class="w-100">
            <el-option
              :label="item.name"
              :value="item.code"
              v-for="item in typeList"
              :key="item.code"
            ></el-option>
          </el-select>
        </div>
        <div class="flex items-center">
          <div class="flex w-80px">问题:</div>
          <el-input v-model="form.title" class="w-100"></el-input>
        </div>
        <div>
          <div>内容:</div>
          <div class="mt-8px">
            <Tinymce @listenChangeEditorValue="changeEditorValue" :value="form.content"></Tinymce>
          </div>
        </div>
        <div class="flex items-center justify-end mt-15px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { typeListApi, addQuestionApi as add, updateQuestionApi as update } from '@/api/help-center'
import utils from 'my-tools-library'
import Tinymce from '@/components/tinymce'

export default {
  components: { Tinymce },
  data() {
    return {
      visible: false,
      type: '',
      form: {},
      typeList: []
    }
  },
  created() {
    // this.open({})
  },
  methods: {
    baseForm() {
      return {
        title: '',
        content: '',
        refCategory: ''
      }
    },
    getType() {
      const params = {
        pageIndex: 1,
        pageSize: 1000
      }
      typeListApi(params).then((res) => {
        const { records } = res.data
        this.typeList = records
        console.log('分类 :>> ', res, this.typeList)
      })
    },
    open(opt) {
      const { type, row } = opt
      console.log('row :>> ', row)
      this.type = type
      if (type === 'edit') this.form = utils.deepCopy(row)
      if (type === 'created') this.form = this.baseForm()
      this.getType()
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },
    changeEditorValue(val) {
      this.form.content = val
    },
    confirm() {
      // eslint-disable-next-line no-unused-expressions
      this.type === 'edit' ? this.handleUpdate() : this.handleAdd()
    },
    handleAdd() {
      console.log('form :>> ', this.form)
      if (!this.form.title || !this.form.content || !this.form.refCategory) {
        this.$message.error('请填写完整')
        return
      }
      add(this.form).then((res) => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.close()
        console.log('res :>> ', res)
      })
    },
    handleUpdate() {
      update(this.form).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.close()
      })
    }
  }
}
</script>
